/**
 * The data recieved from the todos notification API cannot be parsed into JSON data
 * using `JSON.parse.`
 *
 * The data is of the format:
 * {"Id":"","RequestId":"","Operation":"Created","Payload":{"Body":{},"Type":"Task"}\n{...}\n{...}
 *
 * This logic to parse notifications was taken from notification processing
 * code in the todo module code here: https://alexanderplatz.visualstudio.com/To-Do/_git/to-do-web?path=%2Fpackages%2Ftodo-sync%2Fsrc%2FRealTime%2FStream.ts&version=GBmaster
 * @param responseText responseText from todo notification
 */
export function parseResponse(responseText: string): { unparsedBytes: number; parsedItems: any[] } {
    const START_SYMBOL = '{';
    const END_SYMBOL = '}';
    const QUOTE_SYMBOL = '"';
    const ESCAPE_SYMBOL = '\\';

    let offset = 0;
    let bracesCount = 0;
    let unparsedBytes = 0;
    let quoteOpened = false;
    // Break the string object into objects
    const responseItems: string[] = [];

    for (let i = 0; i < responseText.length; i++) {
        if (responseText[i] === START_SYMBOL) {
            if (bracesCount === 0) {
                offset = i;
            }
            bracesCount++;
        } else if (responseText[i] === QUOTE_SYMBOL && responseText[i - 1] !== ESCAPE_SYMBOL) {
            quoteOpened = !quoteOpened;
        }

        if (!quoteOpened && responseText[i] === END_SYMBOL) {
            bracesCount--;
            if (bracesCount === 0) {
                responseItems.push(responseText.substring(offset, i + 1));
            }
        }
    }

    if (bracesCount > 0) {
        responseItems.push(responseText.substring(offset));
    }

    const parsedItems: any[] = responseItems.reduce((result: any[], item: string) => {
        let parsedItem;
        try {
            parsedItem = JSON.parse(item);
        } catch (error) {
            unparsedBytes += item.length;
        }
        if (parsedItem) {
            result.push(parsedItem);
        }
        return result;
    }, []);

    return {
        unparsedBytes,
        parsedItems,
    };
}
